/**
 * @namespace {BX.UI}
 */
export default class AlertIcon
{
	static NONE = '';
	static INFO = 'ui-alert-icon-info';
	static WARNING = 'ui-alert-icon-warning';
	static DANGER = 'ui-alert-icon-danger';
	static FORBIDDEN = 'ui-alert-icon-forbidden';
}